// Generated types for VersioningBranch
// This file is auto-generated - do not edit manually

import { z } from 'zod';

import { VersioningRowReadAPI, VersioningRowWriteAPI } from './versioningrow';
import { VersioningRowReadAPISchemaObject, VersioningRowWriteAPISchemaObject } from './versioningrow';

// ============================================================================
// TypeScript Interfaces
// ============================================================================

export interface VersioningBranchReadAPI extends VersioningRowReadAPI {
  /** The island root's id. */
  island_id: string;
  /** Branch name. */
  branch?: string;
  /** Current head commit. */
  head_commit_id?: string | null;
  /** Next commit sequence number. */
  next_seq?: number;
  /** This branch lives under the COW lens (67 §5b): partial twins in the live graph, no shadow island. Cleared on teardown. */
  is_cow?: boolean | null;
  /** Op-stream position this overlay's edits are based on (stamped at registration) — the baseline conflict check runs against everything the target lane appended after it. */
  base_cursor?: number | null;
  /** JSON list of the CONFLICTS the last attempt to merge this branch reported (field / edge / delete_edit, or a constraint violation of the merged state), each with both sides. Written by the merge and announced, so a page watching the island learns of the conflicts the same way it learns of a commit; cleared by the merge that succeeds. Settle them by re-merging with resolutions. */
  merge_conflicts?: string | null;
}

export interface VersioningBranchWriteAPI extends VersioningRowWriteAPI {
  /** The island root's id. */
  island_id: string;
  /** Branch name. */
  branch?: string;
  /** Current head commit. */
  head_commit_id?: string | null;
  /** Next commit sequence number. */
  next_seq?: number;
  /** This branch lives under the COW lens (67 §5b): partial twins in the live graph, no shadow island. Cleared on teardown. */
  is_cow?: boolean | null;
  /** Op-stream position this overlay's edits are based on (stamped at registration) — the baseline conflict check runs against everything the target lane appended after it. */
  base_cursor?: number | null;
  /** JSON list of the CONFLICTS the last attempt to merge this branch reported (field / edge / delete_edit, or a constraint violation of the merged state), each with both sides. Written by the merge and announced, so a page watching the island learns of the conflicts the same way it learns of a commit; cleared by the merge that succeeds. Settle them by re-merging with resolutions. */
  merge_conflicts?: string | null;
}

// ============================================================================
// Zod Schemas
// ============================================================================

export const VersioningBranchReadAPISchemaObject = VersioningRowReadAPISchemaObject.extend({
  island_id: z.string(),
  branch: z.string().optional(),
  head_commit_id: z.string().nullable().optional(),
  next_seq: z.number().optional(),
  is_cow: z.boolean().nullable().optional(),
  base_cursor: z.number().nullable().optional(),
  merge_conflicts: z.string().nullable().optional(),
}).passthrough();
export const VersioningBranchReadAPISchema: z.ZodType<VersioningBranchReadAPI> = VersioningBranchReadAPISchemaObject;

export const VersioningBranchWriteAPISchemaObject = VersioningRowWriteAPISchemaObject.extend({
  island_id: z.string(),
  branch: z.string().optional(),
  head_commit_id: z.string().nullable().optional(),
  next_seq: z.number().optional(),
  is_cow: z.boolean().nullable().optional(),
  base_cursor: z.number().nullable().optional(),
  merge_conflicts: z.string().nullable().optional(),
}).passthrough();
export const VersioningBranchWriteAPISchema: z.ZodType<VersioningBranchWriteAPI> = VersioningBranchWriteAPISchemaObject;
